import Vue from 'vue'
import Vuex from 'vuex'

// Ensure Vuex is used with Vue (optional in Vue 3, but good practice in Vue 2)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
  },
  getters: {
    getUser(state) {
      return state.user
    },
    getLoginToken(state) {
      return state.token
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    },
  },
  actions: {
    updateUser({ commit }, value) {
      commit('setUser', value)
    },
    updateToken({ commit }, value) {
      commit('setToken', value)
    },
  },
  modules: {}
})